// src/components/IconWrapper.tsx
import React from "react";
import type { IconType } from "react-icons";

export interface IconWrapperProps extends React.SVGProps<SVGSVGElement> {
  /** React-Icons icon, e.g. FaUserPlus, FaSearch, etc. */
  icon: IconType;
  /** Optional numeric or string size in pixels (e.g. 12 or "1rem") */
  size?: number | string;
}

/**
 * IconWrapper
 *
 * Renders a React-Icons IconType as a valid JSX.Element,
 * mapping `size` → `width`/`height` so you can write size={12}.
 */
export const IconWrapper: React.FC<IconWrapperProps> = ({
  icon: IconComponent,
  size,
  ...svgProps
}) => {
  // If size is provided, apply it to width/height. Otherwise let CSS/className control it.
  const dimensionProps = size != null
    ? { width: size, height: size }
    : {};

  // Cast to ComponentType so JSX sees it as valid
  const Component = IconComponent as React.ComponentType<any>;

  return <Component {...dimensionProps} {...svgProps} />;
};
